export const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

// Reference: https://www.w3schools.com/JS/js_random.asp
export const RandomNumber = (min, max) => Math.floor(Math.random()*(max-min+1))+min;

/**
 * Shuffles an input array randomly.
 * @param {Array} array An array of object to shuffle.
 * @returns Shuffled Array
 */
export function shuffleArray(array){
  for (let i = 0; i < array.length; i++){
    const newI = Math.floor(Math.random()*(i+1))
    // [array[i], array[newI]] = [array[newI], array[i]]
    const tmp = array[i]
    array[i] = array[newI];
    array[newI] = tmp;
  }
  return array;
}
